var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 38,
    viewBox: "0 0 19 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5312 6.30958H19V0.267583C18.4016 0.18525 16.3434 0 13.9464 0C8.94512 0 5.51908 3.14608 5.51908 8.92842V14.25H6.10352e-05V21.0045H5.51908V38H12.2857V21.0061H17.5815L18.4221 14.2516H12.2841V9.59817C12.2857 7.64592 12.8113 6.30958 15.5312 6.30958Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.7568d81b923c4b03b20863759e0ac207.svg";
export { ForwardRef as ReactComponent };